import { Plugins } from '@leverege/plugin';
import IdentityHistoryAccumulator from "./IdentityHistoryAccumulator.js";
const AccumulatorFactory = Plugins.createFactory('HistoryAccumulator', {
  pluginKey: 'accumulator',
  strategy: Plugins.LOOKUP,
  defaultObject: IdentityHistoryAccumulator
});
function getPoints(model, inPoints, context) {
  const a = AccumulatorFactory.get(model);
  if (a) {
    return a.pointsFor(model, inPoints, context);
  }
  return null;
}
function getAccumulatorsFor(objectType) {
  const filter = accumulator => {
    if (accumulator.objectType == null) {
      return true;
    }
    if (typeof accumulator.objectType === 'string') {
      return accumulator.objectType === objectType;
    }
    if (Array.isArray(accumulator.objectType)) {
      return accumulator.objectType.includes(objectType);
    }
    if (typeof accumulator.objectType === 'function') {
      return accumulator.objectType(objectType);
    }
    return false;
  };
  return Plugins.createView('HistoryAccumulator', {
    name: objectType,
    filter
  }).get();
}
export default {
  getPoints,
  getAccumulatorsFor,
  AccumulatorFactory
};